/**
 * Daily updates, shaped for the screen and for export. Pure.
 */

/** Updates grouped by day, newest day first, in the order they were posted. */
export function groupByDay(updates) {
  const days = new Map();
  for (const u of Array.isArray(updates) ? updates : []) {
    const key = String(u?.date || '').slice(0, 10);
    if (!days.has(key)) days.set(key, []);
    days.get(key).push(u);
  }
  return [...days.entries()]
    .sort(([a], [b]) => (a < b ? 1 : a > b ? -1 : 0))
    .map(([date, items]) => ({
      date,
      items: [...items].sort((x, y) => new Date(x.submitted_at) - new Date(y.submitted_at))
    }));
}

const cell = (value) => {
  const text = String(value ?? '').replace(/\r?\n/g, ' ').trim();
  return /[",]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** One row per update; what a manager pastes into a sheet. */
export function updatesToCsv(updates, formatTime = (v) => v ?? '') {
  const header = ['Date', 'Employee', 'Designation', 'Posted at', 'Done today', 'Next', 'Blockers'];
  const rows = (Array.isArray(updates) ? updates : []).map((u) => [
    String(u.date || '').slice(0, 10),
    u.user?.name ?? `#${u.user_id}`,
    u.user?.designation ?? '',
    formatTime(u.submitted_at),
    u.done,
    u.next_plan,
    u.blockers
  ]);
  return [header, ...rows].map((r) => r.map(cell).join(',')).join('\n');
}

/** Monday of the week `date` falls in, as YYYY-MM-DD in local time. */
export function weekStart(date = new Date()) {
  const d = new Date(date);
  const day = (d.getDay() + 6) % 7;
  d.setDate(d.getDate() - day);
  return toKey(d);
}

export function toKey(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
